import React, { useState, useContext } from 'react';
import { AppContext } from 'context/AppContext';
import moment from 'moment';

const UserDetailsSubInfo = (props) => {
    let appContext = useContext(AppContext);

    let endSubscription = moment(appContext.defaults.sub_end_date);

    var newdate = appContext.defaults.sub_end_date
        ? moment(appContext.defaults.sub_end_date).format('YYYY/MM/DD')
        : '';

    return (
        <>
            <div className="information-about-version-box">
                <div className="information-about-version">
                    {appContext.defaults.sub_is_active
                        ? // ? `Your PRO subscription is valid until ${appContext.defaults.sub_end_date}.`
                          `Your PRO subscription is valid until ${newdate}.`
                        : 'You have a FREE subscription.'}
                </div>
                {appContext.defaults.sub_is_active ||
                props.selectToShowInformation == 'subscription' ? null : (
                    <div
                        onClick={() => {
                            console.log(`go PRO`);
                            props.setSelectToShowInformation('subscription');
                        }}
                        className="go-pro-button"
                    >
                        GO PRO
                    </div>
                )}
            </div>
        </>
    );
};

export default UserDetailsSubInfo;
